<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import Line from '$lib/components/search/autocomplete/Line.svelte';
	import { isRightClick, stopEvent } from '$lib/utils/event';

	interface Props {
		beforeText?: string;
		afterText?: string;
		highlightText?: string;
		additionalLabel?: string;
		onRemoveItemStored?: () => void;
		onSelectItemStored?: () => void;
	}

	const {
		beforeText,
		afterText,
		highlightText,
		additionalLabel,
		onRemoveItemStored,
		onSelectItemStored,
	}: Props = $props();

	function handleRemoveItemStored(e: MouseEvent) {
		stopEvent(e);

		if (isRightClick(e)) {
			return;
		}

		onRemoveItemStored?.();
	}

	function handleSelectItem() {
		onSelectItemStored?.();
	}
</script>

<Icon icon="history" class="text-5 text-coloredneutral relative top-2" />

<Line
	{beforeText}
	{afterText}
	{highlightText}
	{additionalLabel}
	onSelectItem={handleSelectItem}
/>

<Button
	class="relative top-2.5 px-2 h-full"
	variant="ghost"
	icon="close"
	onclick={handleRemoveItemStored}
	onpointerdown={event => event.preventDefault()}
	onmousedown={handleRemoveItemStored}
/>
